export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const encoded = parts.pop().split(';').shift();
        try {
            return decodeURIComponent(encoded);
        } catch {
            // Keep reading legacy values even if they contain an unescaped percent.
            return encoded;
        }
    }
    return null;
};

const authCookieAttributes = () => `Path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;

export const setAuthCookie = (token) => {
    document.cookie = `MMAUTH=${encodeURIComponent(token)}; ${authCookieAttributes()};`;
};

export const clearAuthCookie = () => {
    document.cookie = `MMAUTH=; ${authCookieAttributes()}; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
};
